import React from "react";
import { Reveal } from "../components/Reveal";

const SECTIONS = [
  {
    id: "shipping",
    title: "Shipping Policy",
    body: [
      "Orders are processed within 1–2 business days. Shipping is a flat $49 per order within the contiguous United States unless otherwise noted at checkout.",
      "Wheels and tires typically deliver in 3–7 business days; suspension and lift kits may ship directly from the manufacturer and can take 5–10 business days. Tracking is emailed once your order ships.",
      "Oversized freight (large lift kits, mounted wheel/tire packages) may require a signature and a valid daytime phone number.",
    ],
  },
  {
    id: "returns",
    title: "Return Policy",
    body: [
      "Unmounted, uninstalled products in original packaging may be returned within 30 days of delivery for a refund, less return shipping and any manufacturer restocking fee (typically 15–20%).",
      "Mounted wheels/tires and installed suspension components are not eligible for return. Custom-ordered or special-finish items are final sale.",
      "To start a return, email extremeoffsetrims@gmail.com with your order number. Do not ship anything back without a return authorization.",
    ],
  },
  {
    id: "warranty",
    title: "Warranty",
    body: [
      "All products carry the manufacturer's warranty. Extreme Offset Rims LLC facilitates warranty claims but is not the warranty provider.",
      "Warranty does not cover damage from off-road abuse, improper installation, or exceeding load/speed ratings. Retain your receipt and installation records.",
    ],
  },
  {
    id: "terms",
    title: "Terms of Sale",
    body: [
      "By placing an order you confirm the fitment/specs are correct for your vehicle. Fitment tools are provided as guidance; final verification is the buyer's responsibility.",
      "Sales tax is applied based on your ship-to state where Extreme Offset Rims LLC has nexus. Prices and availability are subject to change.",
      "Extreme Offset Rims LLC · 14740 Heritage Crest Way, Bluffdale, UT 84045 · (385) 226-6398 · extremeoffsetrims@gmail.com",
    ],
  },
];

export default function Policies() {
  return (
    <div className="pt-28 pb-24">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <Reveal>
          <span className="text-xs uppercase tracking-[0.3em] text-[#00f0ff]">The Fine Print</span>
          <h1 className="font-display text-6xl md:text-7xl uppercase leading-none mt-3">Policies</h1>
        </Reveal>
        <div className="mt-12 space-y-12">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.05} id={s.id}>
              <h2 className="font-display text-3xl uppercase mb-4 border-b border-[#27272a] pb-2">{s.title}</h2>
              <div className="space-y-3 text-zinc-300 text-sm leading-relaxed">
                {s.body.map((p, j) => <p key={j}>{p}</p>)}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
